import { IconButton } from '../../../lib/button'
import { FaEraser, FaEdit } from 'react-icons/fa'
import { getTranslatation } from '../../../../locales/translate'

export const Cols = (onRowClickedDelete) => {
  return [
    {
      name: 'Soru',
      selector: 'soru',
      sortable: true,
      width: '300px',
      cell: row => (
        <div style={{ fontSize: 14 }}>
          {row?.soru}
        </div>
      )
    },

    {
      name: 'Cevap',
      selector: 'cevap',
      sortable: true,
      width: '300px',
      cell: row => (
        <div style={{ fontSize: 14 }}>
          {row?.cevap}
        </div>
      )
    },

    {
      name: 'Dil',
      selector: 'langKey',
      sortable: true,
      width: '120px',
      cell: row => (
        <div style={{ fontSize: 14, fontWeight: 'bold', color: row?.langKey === 'en' ? '#1976d2' : '#388e3c' }}>
          {row?.langKey === 'en' ? 'EN' : 'TR'}
        </div>
      )
    },

    {
      name: '',
      selector: 'delete',
      sortable: true,
      width: '90px',
      cell: row => (
        <IconButton
          icon={<FaEraser size={30} />}
          onClick={() => onRowClickedDelete(row.uuid)}
        // disabled={row.users_id < 1000 ? true : false}
        />
      )
    }
  ]
}
